var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "container",
      staticStyle: { height: "100%" },
      on: { click: _vm.allIfreamHide },
    },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "" } },
            [
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div1" }, [_vm._v("数据查询")]),
              ]),
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div2" }, [_vm._v("订单统计数据")]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "orderStyle_one" }, [
        _vm._v(
          " 此页面做了内部系统的订单统计，内部系统详情见平台分类。可以做备货、已备货、发货、验收的操作。操作数据同步在我的订单里面。 "
        ),
      ]),
      _c("el-collapse-transition", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.show3,
                expression: "!show3",
              },
            ],
            staticClass: "inquiry",
          },
          [
            _c("div", { staticClass: "header" }, [
              _c("span", [_vm._v("查询订单")]),
              _c(
                "p",
                {
                  on: {
                    click: function ($event) {
                      _vm.show3 = true
                    },
                  },
                },
                [_vm._v("收起")]
              ),
            ]),
            _c(
              "el-form",
              {
                ref: "form",
                attrs: {
                  inline: true,
                  model: _vm.queryForm,
                  "label-width": "",
                  size: "mini",
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "orderStyle" },
                  [
                    _c(
                      "el-form",
                      { attrs: { size: "mini" } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "订单状态" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  placeholder: "选择订单状态",
                                  filterable: "",
                                  clearable: "",
                                  "default-first-option": "",
                                },
                                on: { change: _vm.handlerSelect },
                                model: {
                                  value: _vm.queryForm.orderStatus,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.queryForm, "orderStatus", $$v)
                                  },
                                  expression: "queryForm.orderStatus",
                                },
                              },
                              _vm._l(_vm.status, function (itemsS) {
                                return _c("el-option", {
                                  key: itemsS.dictId,
                                  attrs: {
                                    label: itemsS.dictName,
                                    value: itemsS.dictId,
                                  },
                                })
                              }),
                              1
                            ),
                            _c("span", { staticClass: "orderStyle_text" }, [
                              _vm._v(
                                ' 订单状态：待备货、已备货、待发货、待签收。"待发货"状态里面有拣货单导出、导出物流数据、导出物流单号。 '
                              ),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "el-form",
                          { attrs: { size: "mini" } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "平台分类" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      placeholder: "选择平台分类",
                                      multiple: "",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.queryForm.platformType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryForm,
                                          "platformType",
                                          $$v
                                        )
                                      },
                                      expression: "queryForm.platformType",
                                    },
                                  },
                                  _vm._l(_vm.platform, function (itemsS) {
                                    return _c("el-option", {
                                      key: itemsS.dictId,
                                      attrs: {
                                        value: itemsS.dictId,
                                        label: itemsS.dictName,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "姓名/手机号" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入客户手机号码/姓名" },
                      model: {
                        value: _vm.queryForm.customerKeyWord,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryForm, "customerKeyWord", $$v)
                        },
                        expression: "queryForm.customerKeyWord",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "订单编号" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入订单编号" },
                      model: {
                        value: _vm.queryForm.orderNo,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryForm, "orderNo", $$v)
                        },
                        expression: "queryForm.orderNo",
                      },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "selectDate" }, [
                  _c("span", [_vm._v("付款时间")]),
                  _c(
                    "div",
                    { staticClass: "picker" },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "daterange",
                          "unlink-panels": "",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          format: "yyyy-MM-dd",
                          "value-format": "yyyy-MM-dd",
                        },
                        on: { input: _vm.immediUpdate },
                        model: {
                          value: _vm.date,
                          callback: function ($$v) {
                            _vm.date = $$v
                          },
                          expression: "date",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c(
                  "el-form-item",
                  { attrs: { label: "部门选择" } },
                  [
                    _c("el-cascader", {
                      attrs: {
                        options: _vm.options,
                        props: {
                          multiple: true,
                          checkStrictly: true,
                          label: "orgName",
                          value: "orgCode",
                          children: "children",
                        },
                      },
                      model: {
                        value: _vm.queryForm.orgName,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryForm, "orgName", $$v)
                        },
                        expression: "queryForm.orgName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "客服" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          clearable: "",
                          placeholder: "请选择客服",
                          "default-first-option": true,
                        },
                        model: {
                          value: _vm.queryForm.service,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm, "service", $$v)
                          },
                          expression: "queryForm.service",
                        },
                      },
                      _vm._l(_vm.customer, function (items) {
                        return _c("el-option", {
                          key: items.id,
                          attrs: { label: items.reallyName, value: items.id },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "selectDate" }, [
                  _c("span", [_vm._v("备货时间")]),
                  _c(
                    "div",
                    { staticClass: "picker" },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "daterange",
                          "unlink-panels": "",
                          "range-separator": "至",
                          "start-placeholder": "起始时间",
                          "end-placeholder": "结束时间",
                          format: "yyyy-MM-dd",
                          "value-format": "yyyy-MM-dd",
                        },
                        model: {
                          value: _vm.date1,
                          callback: function ($$v) {
                            _vm.date1 = $$v
                          },
                          expression: "date1",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "selectDate" }, [
                  _c("span", [_vm._v("发货时间")]),
                  _c(
                    "div",
                    { staticClass: "picker" },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "daterange",
                          "unlink-panels": "",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          format: "yyyy-MM-dd",
                          "value-format": "yyyy-MM-dd",
                        },
                        on: { input: _vm.immediUpdate },
                        model: {
                          value: _vm.date2,
                          callback: function ($$v) {
                            _vm.date2 = $$v
                          },
                          expression: "date2",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: {
                          click: _vm.searchEvent,
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.searchEvent.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("搜索")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", plain: "" },
                        on: { click: _vm.reset },
                      },
                      [_vm._v("重置")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "boxBtns" },
        [
          _c(
            "div",
            { staticClass: "btnSh" },
            [
              this.queryForm.orderStatus == 1 || this.queryForm.orderStatus == 4
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.approval },
                    },
                    [_vm._v("批量审核")]
                  )
                : _vm._e(),
              this.queryForm.orderStatus == 2
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "success", size: "mini" },
                      on: { click: _vm.physical },
                    },
                    [_vm._v("拣货单导出")]
                  )
                : _vm._e(),
              this.queryForm.orderStatus == 2
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "warning", size: "mini" },
                      on: { click: _vm.exportData },
                    },
                    [_vm._v("导出物流数据")]
                  )
                : _vm._e(),
              this.queryForm.orderStatus == 2
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "danger", size: "mini" },
                      on: {
                        click: function ($event) {
                          _vm.leadingIn = true
                        },
                      },
                    },
                    [_vm._v("导入物流单号")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm.show3
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: {
                    click: function ($event) {
                      _vm.show3 = false
                    },
                  },
                },
                [_vm._v("搜索展开")]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table", on: { click: _vm.allIfreamHide } },
        [
          _c(
            "vxe-table",
            {
              ref: "xtable",
              staticClass: "xtable",
              staticStyle: { "min-height": "400px" },
              attrs: {
                size: "small",
                data: _vm.dataList,
                "expand-config": { expandAll: true },
                "sort-config": { trigger: "cell" },
                align: "center",
              },
              on: {
                "checkbox-all": _vm.selectAllEvent,
                "checkbox-change": _vm.selectChangeEvent,
              },
            },
            [
              _c("vxe-table-column", {
                attrs: { type: "checkbox", width: "40" },
              }),
              _c("vxe-table-column", {
                attrs: { type: "seq", title: "序号", width: "55" },
              }),
              _c("vxe-table-column", {
                attrs: { title: "订单编号", "min-width": "120px" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: "单击复制",
                              placement: "top",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: { cursor: "pointer" },
                                on: {
                                  click: function ($event) {
                                    return _vm.copyButton(props.row.orderNo)
                                  },
                                },
                              },
                              [
                                _c("span", [
                                  _vm._v(" " + _vm._s(props.row.orderNo)),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: { title: "收货人姓名", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c(
                          "p",
                          {
                            staticStyle: { cursor: "pointer" },
                            on: {
                              click: function ($event) {
                                return _vm.tosee(props.row)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(props.row.receiptName) + " ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: { title: "收货人电话", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _vm._v(" " + _vm._s(props.row.receiptPhone) + " "),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: { title: "平台分类", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              props.row.platformType == 1
                                ? "宜关小程序"
                                : "" || props.row.platformType == 2
                                ? "天兰小程序"
                                : "" || props.row.platformType == 3
                                ? "九航云选小程序"
                                : "" || props.row.platformType == 4
                                ? "九航云选APP"
                                : "" || props.row.platformType == 5
                                ? "五域创客"
                                : "" || props.row.platformType == 6
                                ? "九航大健康"
                                : ""
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: { title: "订单状态", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c("p", { staticStyle: { color: "red" } }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                props.row.orderStatus == 1
                                  ? "待备货"
                                  : "" || props.row.orderStatus == 2
                                  ? "待发货"
                                  : "" || props.row.orderStatus == 3
                                  ? "待签收"
                                  : "" || props.row.orderStatus == 4
                                  ? "已备货"
                                  : ""
                              ) +
                              " "
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: { title: "商品名称", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return _vm._l(props.row.orderInfoList, function (item) {
                        return _c("p", { key: item.value }, [
                          _vm._v(" " + _vm._s(item.productName) + " "),
                        ])
                      })
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: { title: "商品数量", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return _vm._l(props.row.orderInfoList, function (item) {
                        return _c("p", { key: item.value }, [
                          _vm._v(" " + _vm._s(item.productNum) + " "),
                        ])
                      })
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: { title: "金额", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c("p", [
                          _vm._v("支付：￥" + _vm._s(props.row.payAmount)),
                        ]),
                        _c("p", [
                          _vm._v("已收：￥" + _vm._s(props.row.receivedAmount)),
                        ]),
                        _c("p", [
                          _vm._v("待收：￥" + _vm._s(props.row.waitAmount)),
                        ]),
                        _c("p", [
                          _vm._v(
                            "优惠：￥" + _vm._s(props.row.preferentialAmount)
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: { title: "收货信息", "min-width": "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _vm._v(" " + _vm._s(props.row.receiptAddress) + " "),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: { title: "备注", "min-width": "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [_vm._v(" " + _vm._s(props.row.remark) + " ")]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: { title: "付款时间", width: "90", field: "payTime" },
              }),
              _c("vxe-table-column", {
                attrs: {
                  title: "发货时间",
                  width: "90",
                  field: "dispatchTime",
                },
              }),
              _c("vxe-table-column", {
                attrs: { title: "备货时间", width: "90", field: "readyTime" },
              }),
              _c("vxe-table-column", {
                attrs: { title: "操作", fixed: "right", "min-width": "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c("div", { staticClass: "btn" }, [
                          props.row.platformType == 5 &&
                          props.row.orderStatus != 3 &&
                          props.row.orderStatus != 2
                            ? _c("div", [
                                _c(
                                  "span",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.ratify(props.row, 1)
                                      },
                                    },
                                  },
                                  [_vm._v("批准")]
                                ),
                                _c(
                                  "span",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.fixOrder(props.row, 2)
                                      },
                                    },
                                  },
                                  [_vm._v("办理")]
                                ),
                              ])
                            : _vm._e(),
                          (props.row.orderStatus == 3 ||
                            props.row.orderStatus == 2) &&
                          props.row.platformType == 5
                            ? _c("div", [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "#bbb",
                                      cursor: "no-drop",
                                    },
                                  },
                                  [_vm._v("该状态无需审批")]
                                ),
                              ])
                            : _vm._e(),
                          props.row.platformType != 5
                            ? _c(
                                "span",
                                {
                                  staticStyle: {
                                    color: "#bbb",
                                    cursor: "no-drop",
                                  },
                                },
                                [_vm._v("该平台仅支持批量操作")]
                              )
                            : _vm._e(),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("div", { staticStyle: { height: "40px" } }),
        ],
        1
      ),
      _c("div", { staticClass: "page" }, [
        _c(
          "div",
          { staticClass: "block" },
          [
            _c("el-pagination", {
              attrs: {
                "current-page": _vm.currentPage1,
                "page-sizes": [10, 20, 50, 100],
                "page-size": _vm.pageSize,
                layout: "total, sizes, prev, pager, next, jumper",
                total: _vm.totalNum,
                "prev-text": "上一页",
                "next-text": "下一页",
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dowith, "append-to-body": true, title: "办理" },
          on: {
            "update:visible": function ($event) {
              _vm.dowith = $event
            },
            close: function ($event) {
              _vm.textarea = ""
            },
          },
        },
        [
          _c(
            "span",
            { staticStyle: { display: "inline-block", "line-height": "30px" } },
            [_vm._v("审批意见:")]
          ),
          _c("el-input", {
            attrs: { type: "textarea", placeholder: "请输入内容" },
            model: {
              value: _vm.textarea,
              callback: function ($$v) {
                _vm.textarea = $$v
              },
              expression: "textarea",
            },
          }),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dowith = false
                      _vm.approval("批准")
                    },
                  },
                },
                [_vm._v("批 准")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "info" },
                  on: {
                    click: function ($event) {
                      _vm.dowith = false
                      _vm.approval("驳回")
                    },
                  },
                },
                [_vm._v("驳 回")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dowith = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogFormVisible,
            "append-to-body": true,
            title: "审核过程",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            { staticStyle: { width: "100%" }, attrs: { data: _vm.polliing } },
            [
              _c("el-table-column", {
                attrs: { type: "index", label: "步骤", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "任务节点",
                  prop: "taskName",
                  "show-overflow-tooltip": true,
                },
              }),
              _c("el-table-column", {
                attrs: { label: "办理人", prop: "assignee", width: "110" },
              }),
              _c("el-table-column", {
                attrs: { label: "审批开始时间", prop: "startTime" },
              }),
              _c("el-table-column", {
                attrs: { label: "审批结束时间" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        !_vm.is_null(props.row.endTime)
                          ? _c("span", [_vm._v(_vm._s(props.row.endTime))])
                          : _vm._e(),
                        _vm.is_null(props.row.endTime)
                          ? _c("span", [_vm._v("正在处理中...")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "审批意见", "show-overflow-tooltip": true },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        !_vm.is_null(props.row.comment)
                          ? _c("span", [_vm._v(_vm._s(props.row.comment))])
                          : _vm._e(),
                        _vm.is_null(props.row.comment)
                          ? _c("span", [_vm._v("/")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.leadingIn,
            "append-to-body": true,
            width: "21%",
            title: "物流单号导入",
          },
          on: {
            "update:visible": function ($event) {
              _vm.leadingIn = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "popIn" },
            [
              _c(
                "el-upload",
                {
                  ref: "my-upload",
                  staticClass: "upload-demo",
                  attrs: {
                    drag: "",
                    action: "#",
                    multiple: false,
                    "http-request": _vm.orderImport,
                    limit: 1,
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-upload" }),
                  _c("div", { staticClass: "el-upload__text" }, [
                    _vm._v("将文件拖到此处，或"),
                    _c("em", [_vm._v("点击上传")]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function ($event) {
                      _vm.leadingIn = false
                      _vm.DownloadTemplate()
                    },
                  },
                },
                [_vm._v("下载模板")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function ($event) {
                      _vm.leadingIn = false
                      _vm.popInAxios(1)
                    },
                  },
                },
                [_vm._v("批量暂存")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: {
                    click: function ($event) {
                      _vm.leadingIn = false
                      _vm.popInAxios(0)
                    },
                  },
                },
                [_vm._v("批量发货")]
              ),
              _c(
                "el-button",
                { attrs: { size: "mini" }, on: { click: _vm.cancel } },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.logisPoper,
            "append-to-body": true,
            title: "物流查询详情",
          },
          on: {
            "update:visible": function ($event) {
              _vm.logisPoper = $event
            },
          },
        },
        [
          _vm.logistlist.base64T === undefined
            ? _c("div", [
                _c("p", { staticClass: "logHeader" }, [
                  _c("span", [_vm._v(_vm._s(_vm.logistlist.expTextName))]),
                  _c("span", [_vm._v(_vm._s(_vm.logistlist.mailNo))]),
                ]),
                _vm.logistlist.status != 1
                  ? _c(
                      "div",
                      { staticClass: "trackingNode" },
                      [
                        _c(
                          "el-steps",
                          { attrs: { direction: "vertical", active: 0 } },
                          _vm._l(_vm.logistlist.data, function (pre, index) {
                            return _c("el-step", {
                              key: index,
                              staticClass: "stepSuc",
                              staticStyle: {
                                "flex-grow": "1",
                                "min-height": "80px",
                              },
                              attrs: {
                                title: "审批人" + pre.context,
                                description: pre.time,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.logistlist.status == 1
                  ? _c(
                      "span",
                      {
                        staticStyle: {
                          "font-weight": "600",
                          "font-size": "18px",
                        },
                      },
                      [_vm._v("提示暂未查询到物流信息")]
                    )
                  : _vm._e(),
              ])
            : _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "column",
                    "align-items": "center",
                    height: "400px",
                    overflow: "auto",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "20px",
                        "font-weight": "600",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.logistlist.name + " " + _vm.logistlist.id
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c("div", [
                    _c("img", {
                      attrs: {
                        src: "data:image/png;base64," + _vm.logistlist.base64T,
                      },
                    }),
                  ]),
                ]
              ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.delivery,
            "append-to-body": true,
            title: "填写出库信息",
          },
          on: {
            "update:visible": function ($event) {
              _vm.delivery = $event
            },
          },
        },
        [
          _c("div", { staticClass: "aloneDeliveryHouse" }, [
            _c(
              "div",
              {
                staticClass: "line",
                staticStyle: {
                  display: "flex",
                  "justify-content": "flex-start",
                },
              },
              [
                _c(
                  "p",
                  [
                    _c("span", [_vm._v("出库仓库")]),
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          placeholder: "请选择出库仓库(选填)",
                          clearable: "",
                        },
                        model: {
                          value: _vm.logist.wareOut,
                          callback: function ($$v) {
                            _vm.$set(_vm.logist, "wareOut", $$v)
                          },
                          expression: "logist.wareOut",
                        },
                      },
                      _vm._l(_vm.warelist, function (items) {
                        return _c("el-option", {
                          key: items.id,
                          attrs: {
                            label: items.name + "-(" + items.keeper + ")",
                            value: items.id,
                          },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "line",
                staticStyle: {
                  display: "flex",
                  "justify-content": "flex-start",
                },
              },
              [
                _c(
                  "p",
                  [
                    _c("span", [_vm._v("物流公司")]),
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "物流公司",
                          filterable: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.logist.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.logist, "name", $$v)
                          },
                          expression: "logist.name",
                        },
                      },
                      _vm._l(_vm.companys, function (itemsS) {
                        return _c("el-option", {
                          key: itemsS.dictName,
                          attrs: {
                            label: itemsS.dictName,
                            value: itemsS.dictName,
                          },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "p",
                  [
                    _c("span", [_vm._v("物流单号")]),
                    _c("el-input", {
                      attrs: { placeholder: "请填写物流单号" },
                      model: {
                        value: _vm.logist.number,
                        callback: function ($$v) {
                          _vm.$set(_vm.logist, "number", $$v)
                        },
                        expression: "logist.number",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.orderTS },
                },
                [_vm._v("单号暂存")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.delivery = false
                      _vm.deliveryTrue()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function ($event) {
                      _vm.delivery = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.modify,
            "append-to-body": true,
            title: "修改代收价格",
          },
          on: {
            "update:visible": function ($event) {
              _vm.modify = $event
            },
          },
        },
        [
          _c("div", { staticClass: "aloneDelivery" }, [
            _c("p", [
              _c("span", [_vm._v("订单编号：")]),
              _c("span", [_vm._v(_vm._s(_vm.modifyPrice.orderIdStr))]),
            ]),
            _c("p", [
              _c("span", [_vm._v("总金额: ")]),
              _c("span", [_vm._v("￥" + _vm._s(_vm.modifyPrice.money))]),
            ]),
            _c("p", [
              _c("span", [_vm._v("已收金额：")]),
              _c("span", [
                _vm._v("￥" + _vm._s(_vm.modifyPrice.receivedMoney)),
              ]),
            ]),
            _c("p", [
              _c("span", [_vm._v("剩余代付金额：")]),
              _c("span", [
                _vm._v("￥" + _vm._s(_vm.modifyPrice.awaitIncomeMoney)),
              ]),
            ]),
            _c(
              "p",
              [
                _c("span", [_vm._v("待收金额")]),
                _c("el-input", {
                  attrs: { placeholder: "请填写待收金额" },
                  model: {
                    value: _vm.moneyWait,
                    callback: function ($$v) {
                      _vm.moneyWait = $$v
                    },
                    expression: "moneyWait",
                  },
                }),
              ],
              1
            ),
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.waitLogiterMoney()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.modify = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.updateOddVis,
            "append-to-body": "",
            title: "修改快递单号",
          },
          on: {
            "update:visible": function ($event) {
              _vm.updateOddVis = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "fixNumber" },
            [
              _c("span", [_vm._v("物流公司")]),
              _c(
                "el-select",
                {
                  attrs: {
                    placeholder: "物流公司",
                    filterable: "",
                    clearable: "",
                  },
                  model: {
                    value: _vm.updateOddObj.logisticsCompany,
                    callback: function ($$v) {
                      _vm.$set(_vm.updateOddObj, "logisticsCompany", $$v)
                    },
                    expression: "updateOddObj.logisticsCompany",
                  },
                },
                _vm._l(_vm.companys, function (itemsS) {
                  return _c("el-option", {
                    key: itemsS.dictName,
                    attrs: { label: itemsS.dictName, value: itemsS.dictName },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "fixNumber" },
            [
              _c("span", [_vm._v("快递单号")]),
              _c("el-input", {
                staticStyle: { width: "200px", "margin-top": "20px" },
                attrs: { placeholder: "请输入新的快递单号" },
                model: {
                  value: _vm.updateOddObj.parcelNumber,
                  callback: function ($$v) {
                    _vm.$set(_vm.updateOddObj, "parcelNumber", $$v)
                  },
                  expression: "updateOddObj.parcelNumber",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.updateOdd },
                },
                [_vm._v("确 定")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "info", size: "small", plain: "" },
                  on: {
                    click: function ($event) {
                      _vm.updateOddVis = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.headerTitle,
            visible: _vm.dialogOperation,
            width: "30%",
            "before-close": _vm.handleCloseOperation,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogOperation = $event
            },
          },
        },
        [
          _c(
            "el-form",
            [
              _c(
                "el-form-item",
                { attrs: { label: "审批意见" } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea" },
                    model: {
                      value: _vm.comment,
                      callback: function ($$v) {
                        _vm.comment = $$v
                      },
                      expression: "comment",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.turnDown } }, [
                _vm._v("驳回"),
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.approve } },
                [_vm._v("批准")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }